import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../common/components/T';
import css from './Package.module.scss';
import classnames from 'classnames';
import { generateGridStyles } from '../../components/helpers';
import { generateUniqueId } from '../../../../common/utils/utils';
import Image from 'next/image';

const Package = ({ getHandlers, val, translation, gridStyles, name }) => {
    const { stylers, existCl } = generateGridStyles(gridStyles, name);
    return (
        <div key={generateUniqueId()} {...getHandlers(false)} className={existCl.wrapper || css.flexRow} style={stylers.wrapper}>
            <div className={css.packageIcon}>
                <Image
                    className={classnames(`packageIcon${val?.id || 0}`)}
                    src={`/src/img/packages/package${val?.id || 0}.png`}
                    alt={`package${val?.id || 0}`}
                    fill
                />
            </div>
            <p style={stylers.small} className={existCl('small') || classnames(css.orderStatus, css.orderStatusWeb)}>
                {!!val
                    ? typeof val === 'string'
                        ? val
                        : val?.name || t('EmptyPackages', 'Отсутсвует', 'widget', translation, 'grid')
                    : t('EmptyPackages', 'Отсутсвует', 'widget', translation, 'grid')}
            </p>
            {!!val && val?.package_from ? <p className={css.packageFrom}>{val?.package_from}</p> : null}
        </div>
    );
};
Package.propTypes = {
    getHandlers: PropTypes.func,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
};
export default Package;
